<div class="close-button-container" (click)="dismiss()"><smart-icon name="f" ></smart-icon></div>
<div class="info-container">
    <img *ngIf="values['img']" [src]="this.values['img'] | toLocalUrl | async">
    <label>{{this.values['productNmane']}}</label>
    <div class="rows-container">
        <div class="single-row" *ngFor="let row of this.values['values']">
            <label class="name">{{row.label}}:</label>
            <div class="values-container">
                <div class="value-container" *ngFor="let value of this.row['value']">
                    <label class="value" [innerHTML]="value"></label>
                    <div class="divider"></div>
                </div>
            </div>
        </div>
    </div>
</div>
